import { useCallback } from "react";

const useFormattedDate = () => {
  const formatDateForInput = useCallback((dateString: string): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  }, []);

  return { formatDateForInput };
};

export default useFormattedDate;
